class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById("cart-notification");
    this.header = document.querySelector("sticky-header");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.body = document.querySelector('body');

    this.notification.addEventListener(
      "keyup",
      (evt) => evt.code === "Escape" && this.close()
    );
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener("click", this.close.bind(this))
    );
  }

  open() {  
    this.notification.parentElement.classList.add("active");
    this.body.classList.add("minicart__open");

    const handleTransitionEnd = () => {
      this.notification.focus();
      window.trapFocus(this.notification);
      document.body.classList.add('overflow-hidden--tablet-down');
    }

    this.notification.addEventListener(
      "transitionend",
      handleTransitionEnd,
      { once: true }
    );

    setTimeout(handleTransitionEnd, 300);

    document.body.addEventListener('touchstart', this.onBodyClick, { passive: false });
    document.body.addEventListener("click", this.onBodyClick);
  }

  close() {
    this.notification.parentElement.classList.remove("active");
    this.body.classList.remove("minicart__open");

    document.body.removeEventListener('touchstart', this.onBodyClick);
    document.body.removeEventListener("click", this.onBodyClick);

    window.removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden--tablet-down');
  }

  renderContents(parsedState) {
    this.productId = Array.isArray(parsedState.items)
      ? parsedState.items[0].id
      : parsedState.id;
    this.getSectionsToRender().forEach((section) => {
      if(document.getElementById(section.id)){
        document.getElementById(section.id).innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });

    if (Array.isArray(parsedState.items) && window.B2B != true) {
      parsedState.items.slice(1).forEach((item) => {
        this.productId = item.id;
        const section = this.getSectionsToRender()[0];
        document
          .getElementById(section.id)
          .insertAdjacentHTML(
            "beforeend",
            this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            )
          );
      });
    }
    if (this.header) this.header.reveal();
    this.open();
    window.convertCurrency(this);
  }

  getSectionsToRender() {
    return [
      {
        id: "cart-notification-products",
        section: "cart-notification-products",
        selector: `[id="cart-notification-product-${this.productId}"]`,
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
      },
      {
        id: "cart-notifications-wrapper",
        section: "cart-notifications",
      },
      {
        id: "mini-cart-upsell",
        section: "mini-cart-upsell",
        selector: `[id="mini-cart-upsell-${this.productId}"]`
      }
      // {
      //   id: "cart-notification-spend-tracker",
      //   section: "spend-tracker",
      // },
      // {
      //   id: "cart-notification-shipping",
      //   section: "shipping-notifications",
      // },
      // {
      //   id: "cart-notification-gift-selector",
      //   section: "gift-selector-tracker",
      // },
    ];
  }

  getSectionInnerHTML(html, selector = ".shopify-section") {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(event) {
    const target = event.target;
    if (target !== this.notification && !this.notification.contains(target)) {
      event.type === 'touchstart' && event.preventDefault();
      const disclosure = target.closest("details-disclosure");
      this.activeElement = disclosure
        ? disclosure.querySelector("summary")
        : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define("cart-notification", CartNotification);